import { render, staticRenderFns } from "./NavigationSide.vue?vue&type=template&id=789ca1af&scoped=true&"
import script from "./NavigationSide.vue?vue&type=script&lang=js&"
export * from "./NavigationSide.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSide.vue?vue&type=style&index=0&id=789ca1af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ca1af",
  null
  
)

export default component.exports